import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import PortraitIcon from "@mui/icons-material/Portrait";
import { modalstyle, muiAbtn, muiBbtn, starIcon } from "./style";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import AddIcon from "@mui/icons-material/Add";
import Rating from "@mui/material/Rating";
import CreativeImage from "./CreativeImage";
import {
  collection,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  onSnapshot,
  doc,
  Timestamp,
  query,
  orderBy,
  deleteDoc,
  limit,
  where,
  getDoc,
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import { db } from "../firebase";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  maxHeight: "600px",
  overflowY: "scroll",
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function AllProducts() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [Category, setCategory] = useState("");
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [DocId, setDocId] = useState(-1);

  useEffect(() => {
    let active = true;
    const getData = async () => {
      setLoading(true);
      /////Getting the latest document first.

      onSnapshot(
        query(collection(db, "orders"), orderBy("created_at", "desc")),
        (data) => {
          //////Mapping Through App Documents And Then Saving them in rows useState.
          setLoading(false);
          data.docs.map((document) => {
            getDoc(doc(db, "users", document.data().uid)).then((u) => {
              setRows((row) => [
                ...row,
                {
                  ...document.data(),
                  id: document.id,
                  user_name: u.data().displayName,
                },
              ]);
            });
          });
        }
      );

      return () => {
        setRows([]);
      };
    };
    getData();
  }, []);
  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [SelectedOrder, setSelectedOrder] = useState("");
  const [isProcessing, setisProcessing] = useState(false);
  const [OrderDetails, setOrderDetails] = useState({});
  const [UserName, setUserName] = useState("");
  const [Status, setStatus] = useState("");

  const handleOpen = (index, status) => {
    setDocId(index);
    setStatus(status);
    setOpen(true);
  };
  const handleOpenView = (index) => {
    setOpenView(true);
    getDoc(doc(db, "orders", index)).then((data) => {
      setOrderDetails(data.data());
      getDoc(doc(db, "users", data.data().uid)).then((ud) => {
        setUserName(ud.data().displayName);
      });
    });
  };
  const handleClose = () => {
    setOpen(false);
    setOpenView(false);
  };

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setSelectedOrder(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedOrder("");
  };

  const updateOrder = () => {
    setisProcessing(true);
    updateDoc(doc(db, "orders", DocId), { status: Status })
      .then(() => {
        setisProcessing(false);
        toast.success("Order Updated");
        handleClose();
        setRows(
          rows.map((item) => {
            if (item.id === DocId) {
              return { ...item, status: Status };
            } else {
              return item;
            }
          })
        );
      })
      .catch((error) => {
        setisProcessing(false);
        toast.error("Error Failed To Update.");
        console.log(error);
      });
  };
  const deleteOrder = () => {
    deleteDoc(doc(db, "orders", SelectedOrder))
      .then(() => {
        toast.info("Order Deleted");
        setRows(rows.filter((row) => row.id !== SelectedOrder));
        handleCloseDialog();
      })
      .catch((error) => {
        toast.error("Error! Filed to delete oreder");
      });
  };

  const columns = [
    // { field: "id", headerName: "ID", width: "60" },
    {
      field: "id",
      headerName: "",
      width: "100",
      align: "left",
    },
    {
      field: "ItemsNo",
      headerName: "",
      width: "100",
      align: "left",
      renderCell: ItemsNo,
    },
    {
      field: "total",
      headerName: "",
      width: "100",
      align: "center",
    },
    {
      field: "user_name",
      headerName: "",
      width: "200",
      align: "center",
    },
    {
      field: "status",
      headerName: "",
      width: "200",
      align: "center",
    },

    {
      field: "Action",
      width: "280",
      align: "right",

      editable: false,
      renderCell: ActionButton,
    },
  ];

  function ItemsNo(params) {
    return <>{params.row.items.length} Items</>;
  }

  function ActionButton(params) {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          startIcon={<RemoveRedEyeIcon />}
          onClick={() => handleOpenView(params.row.id)}
        >
          View
        </Button>

        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          // startIcon={<CheckCircleIcon />}
          onClick={() => handleOpen(params.row.id, params.row.status)}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
          // startIcon={<CancelIcon />}
        >
          Delete
        </Button>


      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,
        backgroundColor: "#212C62",
      }}
    >
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure to Delete the Order?"}
          </DialogTitle>

          <DialogActions>
            <Button onClick={() => deleteOrder()}>Yes</Button>
            <Button onClick={handleCloseDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Modal
        open={openView}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="w-50">
          <Box mb={3} style={{ display: "flex", justifyContent: "end" }}>
            <CloseIcon
              onClick={handleClose}
              style={{ cursor: "pointer", color: "gray" }}
            />
          </Box>
          <h4 className="mb-4">Order Details</h4>
          <table className="table table-bordered">
            <tr className="py-2">
              <td style={{ minWidth: "150px" }}>
                <b>Order Id</b>
              </td>
              <td> {OrderDetails?.uid}</td>
            </tr>
            <tr className="py-2">
              <td>
                <b>Order By</b>
              </td>
              <td> {UserName}</td>
            </tr>
            <tr className="py-2">
              <td>
                <b>Order Date</b>
              </td>
              {new Timestamp(
                OrderDetails?.created_at?.seconds,
                OrderDetails?.created_at?.nanoseconds
              )
                .toDate()
                .toDateString()}{" "}
              <b>at </b>
              {new Timestamp(
                OrderDetails?.created_at?.seconds,
                OrderDetails?.created_at?.nanoseconds
              )
                .toDate()
                .toTimeString()}
            </tr>
            <tr className="py-2">
              <td>
                <b>Total Items</b>
              </td>
              <td> {OrderDetails?.items?.length}</td>
            </tr>
            <tr className="py-2">
              <td>
                <b>Total Price</b>
              </td>
              <td> {OrderDetails?.total}</td>
            </tr>
            {OrderDetails?.items?.map((item, key) => {
              return (
                <>
                  <tr key={key} className="py-2">
                    <td>
                      <b>Item No {key + 1} </b>
                    </td>
                    <td>
                      {" "}
                      Product ID: {item.uid}
                      <br />
                      <span
                        className="text-primary p-0 m-0"
                        role="button"
                        onClick={() => navigate(`/ViewProduct/${item.uid}`)}
                      >
                        Product : {item.title}
                      </span>
                      <br />
                      {item.variant?.map((v) => {
                        return (
                          <>

                              {v.variantType} : {v.variantValue}<br/>

                          </>
                        );
                      })}

                      Price : {item.price}
                      <br />
                      Quantity : {item.amount}
                      <br />
                    </td>
                  </tr>
                </>
              );
            })}
          </table>
        </Box>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <Box mb={3} style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon
                onClick={handleClose}
                style={{ cursor: "pointer", color: "gray" }}
              />
            </Box>
            <h4 className="mb-4">Update Order</h4>

            {/* <div>
                        <FormControl fullWidth size="small">
                          <TextField
                            className="mb-4"
                            id="email"
                            label="Email"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={Email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </FormControl>
                      </div> */}

            <div className="col">
              <FormControl fullWidth className="mb-4" size="small">
                <InputLabel id="demo-simple-select-label">
                  Select Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={Status}
                  id="admin_Status"
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value="Completed">Completed</MenuItem>
                  <MenuItem value="Inprogress">Inprogress</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                </Select>
              </FormControl>
            </div>
            <Button
              fullWidth
              className="mt-2 muibtn"
              variant="contained"
              color="primary"
              style={muiBbtn}
              size="small"
              disabled={isProcessing}
              onClick={() => updateOrder()}
            >
              {isProcessing ? null : <AddIcon style={{ marginRight: 10 }} />}
              {isProcessing ? (
                <CircularProgress sx={{ color: "white" }} size={27} />
              ) : (
                "Submit"
              )}
            </Button>
          </form>
        </Box>
      </Modal>

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6 mb-4 py-4">
            <h1 className="" style={{ textAlign: "left", color: "#212C62" }}>
              <b>ALL ORDERS</b>
            </h1>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>All Orders</b>
          </h5>
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            // getDocId={(Rows) => Rows._id}
            pageSize={6}
            rowsPerPageOptions={[5]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            disableSelectionOnClick
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
          />
        </div>
      </Card>
    </div>
  );
}
